import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useDemographics } from "~/sdks/LocalDemographics/context";

import { Chart } from "@local-logic/core/ui";

import type { Variable } from "@local-logic/client";

export const MotherTongue = () => {
  const { t } = useTranslation("localDemographics");
  const {
    demographicsState: { mother_tongue: motherTongue },
  } = useDemographics();

  // The reason for the code below is because at the moment we only want to display the first 10 languages.
  // This is because displaying more than 10 languages at a time doesnt fit and ChartJS end up hiding some of the values.
  // french_and non_official_language_s and english_and_non_official_language_s' are too long to be displayed on mobile
  // So they are being filtered out.
  const motherTongueFormatted = useMemo(
    () =>
      motherTongue?.variables
        .filter(
          (item) =>
            item.variable !== "french_and_non_official_language_s" &&
            item.variable !== "english_and_non_official_language_s",
        )
        .slice(0, 10)
        ?.map((variable: Variable) => ({
          ...variable,
          value: Number((variable.value * 100).toFixed(1)),
        }))
        .filter((variable: Variable) => variable.value > 0),
    [motherTongue?.variables],
  );

  const dataset = useMemo(
    () => ({
      labels:
        motherTongueFormatted?.map((variable: Variable) => variable.label) ||
        [],
      data:
        motherTongueFormatted?.map((variable: Variable) => variable.value) ||
        [],
    }),
    [motherTongueFormatted],
  );

  const chartOptions = useMemo(
    () => ({
      title: t("data.languages.graphs.motherTongue.title"),
      labels: dataset.labels,
      data: dataset.data,
      unit: "%",
    }),
    [dataset],
  );

  return (
    <Chart.Root {...chartOptions}>
      <Chart.BarChart />
    </Chart.Root>
  );
};
